export const isDev = !!process.env.NODE_ENV.match(/dev/)
export const API_ROOT = '/api'



// WEBPACK FOOTER //
// ./src/globals.js